/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowsSortCriteria {
    getFixupPrototypeFunction() { return WorkFlowsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowsSortCriteria>): WorkFlowsSortCriteria {
        let obj = Object.assign(new WorkFlowsSortCriteria(), model);
        WorkFlowsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowsSortCriteria>): WorkFlowsSortCriteria {
        if (!model) return null;
        return WorkFlowsSortCriteria.newInstance(<WorkFlowsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowsSortCriteria) {
        if (!obj) return;

        models.WorkFlowsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowsSortCriteria): boolean {
        Object.setPrototypeOf(obj, WorkFlowsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.WorkFlowsSortColumn;

    ascending: boolean;

}
